import { compose, lifecycle } from 'recompose';
import withOwnerTypeAndId from '../withOwnerTypeAndId';
import withPermissions from '../../../auth/utils/withPermissions';
import { withActionByRole } from '../../helpers/actions';
import { refreshShopData } from '../../../main/shops/actions';

// eslint-disable-next-line import/prefer-default-export
export const withRefetchBankAccountOnUnmount = compose(
  withOwnerTypeAndId,
  withPermissions,
  withActionByRole('refreshShopBankAccount', refreshShopData),
  lifecycle({
    componentWillUnmount() {
      this.props.refreshShopBankAccount(this.props.ownerId);
    },
  }),
);
